import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
    NbAuthJWTInterceptor,
    NbAuthModule,
    NbPasswordAuthStrategy,
    NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
    NbTokenLocalStorage,
} from '@nebular/auth';
import {
    NbAlertModule,
    NbButtonModule,
    NbCheckboxModule,
    NbInputModule
} from '@nebular/theme';
import { AuthInterceptor } from './auth.interceptor';
import { AuthGuard } from './auth.guard';
import { AdminGuard } from './admin.guard';
import { environment } from '../../environments/environment';
import { AuthPipe } from './auth.pipe';
import { RoleProvider } from './role.provider';
import { NbRoleProvider, NbSecurityModule } from '@nebular/security';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './pages/login/login.component';
import { RequestPasswordComponent } from './pages/request-password/request-password.component';
import { RegisterComponent } from './pages/register/register.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';

const GUARDS = [AuthGuard, AdminGuard];
const PIPES = [AuthPipe];
const AUTH = [LoginComponent, RequestPasswordComponent, RegisterComponent, ResetPasswordComponent]

export function filterInterceptorRequest(req: HttpRequest<any>): boolean {
    return ['/auth/login', '/auth/sign-up', '/auth/request-pass']
        .some(url => req.url.includes(url));
}

@NgModule({
    declarations: [...PIPES, ...AUTH],
    imports: [
        CommonModule,
        FormsModule,
        NbAlertModule,
        NbInputModule,
        NbButtonModule,
        NbCheckboxModule,
        NbAuthModule.forRoot({
            strategies: [
                NbPasswordAuthStrategy.setup({
                    name: 'email',
                    baseEndpoint: environment.apiUrl,
                    login: {
                        endpoint: '/auth/login',
                        method: 'post',
                        defaultErrors: ['Usuário ou senha inválidos'],
                        defaultMessages: ['Carregando sistema...'],
                    },
                    register: {
                        endpoint: '/auth/sign-up',
                        method: 'post',
                        defaultErrors: ['Algo deu errado, tente novamente'],
                        defaultMessages: ['O registro foi criado com sucesso, carregando sistema...'],
                    },
                    logout: {
                        endpoint: '/auth/sign-out',
                        method: 'post',
                    },
                    requestPass: {
                        endpoint: '/auth/request-pass',
                        method: 'post',
                    },
                    resetPass: {
                        resetPasswordTokenKey: "Token",
                        endpoint: '/auth/reset-pass',
                        method: 'post',
                    },
                    token: {
                        key: 'Token',
                    },
                }),
            ],
        }),
    ],
    exports: [...PIPES],
    providers: [
        NbSecurityModule.forRoot({
            accessControl: {
                guest: {
                },
                user: {
                    parent: 'guest',
                    view: ['/pages/dashboard']
                },
                representante: {
                    parent: 'user',
                    view: ['/pages/consultas', '/pages/pedidos', '/pages/acompanhamento-pedidos', '/pages/solicitacoes-cadastros-clientes']
                },
                admin: {
                    parent: 'representante',
                    view: ['/pages/administracao/usuario', '/pages/administracao/avisos', '/pages/acompanhamento-pedidos', '/pages/administracao/aprovador-pedido']
                },
            },
        }).providers,
        {
            provide: NbRoleProvider, useClass: RoleProvider,
        },
        {
            provide: NbTokenLocalStorage, useClass: NbTokenLocalStorage,
        },
    ],
})
export class AuthModule {
    static forRoot(): ModuleWithProviders {
        return <ModuleWithProviders>{
            ngModule: AuthModule,
            providers: [
                { provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER, useValue: filterInterceptorRequest },
                { provide: HTTP_INTERCEPTORS, useClass: NbAuthJWTInterceptor, multi: true },
                { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
                ...GUARDS],
        };
    }
}
